export enum ExportOption {
    'download' = 'download',
    'export' = 'export',
    'print' = 'print',
    'pdf' = 'pdf',
}
